import React from 'react';
import { LuCircleAlert, LuCircleCheck, LuInfo, LuTriangleAlert } from 'react-icons/lu';

const ICONS = {
  info: LuInfo,
  neutral: LuInfo,
  success: LuCircleCheck,
  warning: LuTriangleAlert,
  danger: LuCircleAlert,
};

const OnboardingAlert = ({ tone = 'info', title, children, action, icon, className = '', style }) => {
  const Icon = ICONS[tone] || LuInfo;
  return (
    <div
      className={`ob-alert ob-alert--${tone} ${className}`}
      role={tone === 'danger' ? 'alert' : 'status'}
      style={style}
    >
      <span className="ob-alert__icon" aria-hidden="true">
        {icon || <Icon size={18} />}
      </span>
      <div className="ob-alert__body">
        {title && <p className="ob-alert__title">{title}</p>}
        {children}
      </div>
      {action && <div className="ob-alert__action">{action}</div>}
    </div>
  );
};

export default OnboardingAlert;
